import React, { useEffect,useState } from "react";
import { Button, Empty, Pagination } from "antd";
import { useNavigate } from "react-router-dom";

import useJDStore from "../../store/jd.store";
import Table from "../Table";

import "./jds.scss";
import Filter from "../filter";

export default function MyJds(props) {

  const navigate = useNavigate();

  const userData = JSON.parse(localStorage.getItem("userDetails"));
  const { getMyJdsPagination, myJdData,myJDsCount } = useJDStore();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
   const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };    

  useEffect(() => {
    //getAllJds();
  }, []);


  const titleList = [
    "Sr. No.",
    "Assigned On",   
    "Client",
    "TA",
    "Job Title",
    "Priority",
    "Status",
    "Total Resumes", 
    "SPOC",
    "Assigned To",
    "BU/Project Name",
    "Hiring Manager",
  ];

  const jdsDetailData = myJdData?.map((jds, idx) => {
    return  {
        id: idx + 1 + (pageSize*(currentPage-1)) ,
        date_added: jds?.JDAssignment?.AssignedOn,
        client_name: jds?.JDClient.ClientName,
        ta: jds?.JDClient.TaName,
        title: '['+jds?.QhCompanyJID+'] '+jds?.JDDetails.Title,
        priority: jds?.JDOther?.Priority,
        status:jds?.JDProject.ReqStatus,
        total_length: jds?.JDResumeList?.length?jds?.JDResumeList?.length:0,
        SPOC: jds?.JDAssignment?.Spoc,
        assignedTo: jds?.JDAssignment?.Assignments?.map(a => a.AssignedToName)?.join(", "),
        bu: jds?.hiring_project_team_name!=null?jds?.hiring_project_team_name:"--",
        hiring_project_team_name: jds?.hiring_project_team_name!=null?jds?.hiring_project_team_name:"--",
      };
  });

  return (
    <div className="jds-wrapper">
      <div>
      <Filter
        filtername = {"getMyJdsPagination"}
        initDuration={"24"}
        initPrio={"All"}
        initResume={"All"}
        initJDStatus={"Active"} 
        initClient={"All"}           
        pageNo = {currentPage}
        pageSize ={pageSize}  
        enableDuration
        enableResumes
        enablePriority
        enableJdStatus
        enableCustomers 
        enableTAs     
        handleFilter={getMyJdsPagination}
        pageHandler = {setCurrentPage}  
      />
      <div></div>
      </div>

      {jdsDetailData?.length > 0 ? (
        <Table
          isClickable={true}
          isJDPage={true}
          titleList={titleList}
          data={jdsDetailData}
          columnWidth={[50, 100, 100, 100, 200, 200, 200, 200, 100, 200, 200, 200]}
        />
      ) : (
        <Empty style={{ margin: "60px" }} />
      )}
      <Pagination
              style={{ marginTop: "4px",  float: "inline-end" }}
              current={currentPage}
              pageSize={pageSize}
              total={myJDsCount}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
                
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
      />       
    </div>
  );
}
